import intl from "react-intl-universal";
import {useAppState} from "@stores/AppStateContext";

import {ItemModelType} from "@stores/WorkspaceStore";

import {resetAcknowledgment} from "../../../../actions/item/resetAcknowledgment";
import {ModalConfirm} from "../../../components/ModalConfirm";

import {MODALS} from "../modal-names";
import {useCrudServices} from "../../../../platform/hooks/useServiceCombinations";

export interface RemoveAcknowledgmentRequireProps {
    itemMST: ItemModelType;
}

export const RemoveAcknowledgmentRequire = (props: RemoveAcknowledgmentRequireProps) => {
    const appState = useAppState();
    const crudServices = useCrudServices();
    const activeModal = appState.topModal;
    const handleConfirm = async () => {
        try {
            await resetAcknowledgment(crudServices, appState.userState!, props.itemMST);
            handleClose();
        } catch (error) {
            console.error('Failed to reset acknowledgment:', error);
        }
    };
    const handleClose = () => appState.setModal(null);

    return (
        <ModalConfirm
            type={'danger'}
            children={intl.get('RemoveAcknowledgmentRequire.reset.confirmation.text').d("Resetting confirmations will erase all current acknowledgments and cancel the acknowledgment request for this page.")}
            onConfirm={handleConfirm}
            onClose={handleClose}
            onCancel={handleClose}
            open={activeModal === MODALS.REMOVE_ACKNOWLEDGMENT_REQUIRE}
            header={intl.get('RemoveAcknowledgmentRequire.reset.confirmation.header').d("Reset Confirmations")}/>
    )
}
